import { TwitterTweetEmbed } from "react-twitter-embed";

import style from "@/components/EmbeddedTweet.module.scss";

const EmbeddedTweet = ({ tweetUrl }) => {
  // Match the numeric string after status
  const regex = /twitter\.com\/.*\/status(?:es)?\/([^\/\?]+)/;
  const tweetMatch = tweetUrl.match(regex);

  const tweetId = tweetMatch?.[1];

  if (!tweetId) return;

  return (
    <div className={style.root}>
      <div className={style.tweet}>
        <TwitterTweetEmbed tweetId={tweetId} />
      </div>
    </div>
  );
};

export default EmbeddedTweet;
